import { defaultPageProps } from '../../../../app/browser/analyticsDefaultProperties';

export default {
  identify: {},
  page: {
    name: 'SP : Welcome Service Categories',
    properties: defaultPageProps,
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/serviceCategoriesAnalytics.js